import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import logo from '../../../assets/axcess logo_reversed-2.svg';
import Box from '../../UI';
import Login from './Login';
import Signup from './Signup';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export default function Auth() {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<div className={classes.root}>
			<div className={classes.background} />
			<div className={classes.polygon} />
			<img className={classes.logo} src={logo} alt="aXcess Logo" />
			<Box className={classes.content}>
				<AppBar className={classes.appbar} position="static">
					<Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
						<Tab
							className={classes.tab}
							label="Login"
							{...a11yProps(0)}
							style={{
								borderBottom: value !== 0 && '1px solid #707070',
							}}
						/>
						<Tab
							className={classes.tab}
							label="Sign Up"
							{...a11yProps(1)}
							style={{
								borderBottom: value !== 1 && '1px solid #707070',
							}}
						/>
					</Tabs>
				</AppBar>
				<TabPanel className={classes.tabPanel} value={value} index={0}>
					<Login />
				</TabPanel>
				<TabPanel className={classes.tabPanel} value={value} index={1}>
					<Signup setValue={setValue} />
				</TabPanel>
			</Box>
		</div>
	);
}

const useStyles = makeStyles(theme => ({
	root: {
		zIndex: 0,
		width: '100vw',
		height: '100vh',
		position: 'relative',
		overflow: 'hidden',
	},
	polygon: {
		zIndex: 2,
		width: '100%',
		height: '100%',
		position: 'absolute',
		top: 0,
		left: 0,
		background: '#000',
		opacity: '10%',
		clipPath: 'polygon(0 0, 27% 0, 50% 67%, 37% 100%, 0 100%)',
	},
	background: {
		zIndex: 1,
		width: '100vw',
		height: '100vh',
		position: 'absolute',
		left: 0,
		top: 0,
		background: '#424242',
	},
	logo: {
		zIndex: 2,
		position: 'absolute',
		top: '64px',
		left: '64px',
		height: '36px',
		[theme.breakpoints.down('sm')]: {
			position: 'relative',
			top: 0,
			left: 0,
			margin: theme.spacing(4),
		},
	},
	content: {
		zIndex: 2,
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		padding: '30px',
		border: '1px solid #707070',
		borderRadius: '10px',
		[theme.breakpoints.down('sm')]: {
			width: '90%',
		},
	},
	appbar: {
		backgroundColor: 'transparent !important',
		boxShadow: 'none',
	},
	tab: {
		width: '50%',
	},
	tabPanel: {
		'& > div': {
			padding: 0,
		},
	},
}));
